import React, { useState, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
const Home = lazy(() => import('./pages/Home'));
const WhatIsPrashnavali = lazy(() => import('./pages/WhatIsPrashnavali'));
const HowPrashnavaliWorks = lazy(() => import('./pages/HowPrashnavaliWorks'));

const App = () => {
    const [odia, setOdia] = useState(false)

    const handleLanguageChange = () => {
        setOdia(!odia)
    }
    return (
        <BrowserRouter>
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <Route path='/' exact render={(props) => <Home {...props} odia={odia} handleLanguageChange={handleLanguageChange} />} />
                    <Route path='/what' component={WhatIsPrashnavali} />
                    <Route path='/how' component={HowPrashnavaliWorks} />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
